import React, { useEffect, useRef, useState } from 'react';

const Footer = ({ onComplianceClick, onPrivacyClick, onTermsClick, onCookieClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const scrollToSection = (sectionId) => {
    if (sectionId === 'hero') {
      // Scroll all the way to top for About/Hero
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 60; // 60px offset for other sections
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 to-slate-800 text-white relative overflow-hidden" id="footer" ref={sectionRef}>
      <div className={`transition-all duration-800 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-16 px-8">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-green-500">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2"/>
                    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span className="text-xl font-bold font-sans">CallSafe</span>
              </div>
              <p className="text-slate-300 mb-6 font-sans">Ethical AI-powered training to protect seniors from phone scams.</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6 font-sans">Contact</h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-slate-400">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
                    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span className="text-slate-300 font-sans">support@callsafe.training</span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6 font-sans">Legal</h3>
              <ul className="space-y-3">
                <li><button onClick={onPrivacyClick} className="text-slate-300 hover:text-white transition-colors font-sans cursor-pointer">Privacy Policy</button></li>
                <li><button onClick={onTermsClick} className="text-slate-300 hover:text-white transition-colors font-sans cursor-pointer">Terms of Service</button></li>
                <li><button onClick={onCookieClick} className="text-slate-300 hover:text-white transition-colors font-sans cursor-pointer">Cookie Policy</button></li>
                <li><button onClick={onComplianceClick} className="text-slate-300 hover:text-white transition-colors font-sans cursor-pointer">Compliance</button></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-slate-700 py-8 px-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-slate-400 mb-4 md:mb-0 font-sans text-center md:text-left">CallSafe Training – Protecting seniors, ethically and effectively.</p>
              <p className="text-slate-400 text-sm font-sans">&copy; 2025 CallSafe. All rights reserved.</p>
            </div>
          </div>
        </div>
    </footer>
  );
};

export default Footer;
